<template lang="pug">
  b-container.pb-5
    b-form-row.align-items-center.mt-3.mb-3
      b-col.my-1
        h4.mb-0 Konverza Shop
    p.text-secondary.mb-3 Konverza Shop es tu tienda en línea incluída con tu chat, comparte este link con tus clientes:
    b-alert.mb-5(show, variant="info")
      h6.mb-0.text-center
        b-link.text-reset(:href="`https://${account.username}.konverza.me`", target="_blank", style="word-break:break-all;") https://{{ account.username }}.konverza.me
          external-link-icon.icon-sm.ml-2.mb-1

    h5.text-center.mb-3 Selecciona tu nombre de usuario
    b-row.mb-5
      b-col.text-center(md="6", offset-md="3")
        b-form-group
          b-input-group(description="Este es el que se usa para la URL tu Konverza Shop")
            b-form-input.text-primary(:placeholder="account.username", v-model="username", debounce="500", :state="usernameState", @input="isUsernameAvailable = true")
            b-input-group-append
              b-button(variant="primary", size="sm", :disabled="validating || username == account.username || usernameState == false", @click="updateAccount('username')") Guardar
          b-form-invalid-feedback(:state="usernameState") {{ usernameState != undefined && usernameState == false ? (!isUsernameAvailable ? 'El nombre de usuario no está disponible' : 'El nombre de usuario solo puede contener letras y números') : null }}
        .mb-3.text-secondary(v-if="suggestion") Sugerencia de nombre:
          b-link.ml-2(@click="isUsernameAvailable = true;username = suggestion") {{ suggestion }}

    h5.mb-3 Personaliza tu tienda
    b-row
      b-col.mb-5(cols="12")
        p.mb-1 Tu logo en la barra superior
        p.text-secondary Se muestra tu logo con una altura de 45 pixeles de alto y un máximo de 200 pixeles de ancho. Si no subes una imagen, se muestra el nombre de usuario.
        .browser-container
          .status-bar.d-flex.align-items-center
            .buttons.red.mr-2
            .buttons.yellow.mr-2
            .buttons.green
          .search-bar
            .bar https://{{ account.username }}.konverza.me
          .w-100.bg-light.py-2.px-3.d-flex.align-items-center(style="height:59px;")
            b-row.align-items-center(style="flex:1;")
              b-col
                h3.mb-0.text-capitalize(v-if="!image") {{ account.username }}
                b-img(v-else, :src="image", :blank="!image", blank-color="#ccc", style="height:45px;max-width:200px;object-fit:scale-down;")
              b-col.d-none.d-md-block(cols="auto")
                p.mb-0.text-secondary Productos
        p.text-sm.text-help.mb-2 Vista previa de logo o nombre de usuario
        input(type="file", accept="image/*", style="display:none;", ref="input_image", @change="imagePicked($event, 'image')")
        div
          b-link.text-sm.mr-3(@click="$refs.input_image.click()") Subir imagen
          b-link.text-sm.text-danger(v-if="image", @click="image = ''") Quitar imagen
        
        .mt-3.text-right
          b-button(variant="primary", @click="updateAccount('shop')", :disabled="loading") Guardar logo

      b-col.mb-5(cols="12")
        p.mb-1 Imagen de portada
        p.text-secondary Tamaño de imagen recomendada 1024 pixeles de ancho por máximo 439 de alto. Trata de centrar la información para evitar que se corten los textos o imágenes.
        .cover-container(v-if="coverPhoto")
          b-img.mb-2(:src="coverPhoto", :blank="!coverPhoto", blank-color="#ccc", style="object-fit:cover;object-position:center;")
        p.text-sm.text-help.mb-2 {{ coverPhoto ? 'Vista previa de imagen de portada' : 'No has seleccionado una imagen de portada' }}
        input(type="file", accept="image/*", style="display:none;", ref="input_coverPhoto", @change="imagePicked($event, 'coverPhoto')")
        div
          b-link.text-sm.mr-3(@click="$refs.input_coverPhoto.click()") Subir imagen
          b-link.text-sm.text-danger(v-if="coverPhoto", @click="coverPhoto = ''") Quitar imagen

        .mt-3.text-right
          b-button(variant="primary", @click="updateAccount('shop')", :disabled="loading") Guardar portada

      b-col.mb-5(cols="12")
        p.mb-1 Color de tienda
        p.text-secondary Puedes personalizar los colores de los botones de agregar al carrito y links dentro de tu tienda.
        b-row
          b-col(md="6", order="2")
            b-img.pointer(width="50", height="50", blank, :blank-color="dashboardColor || '#f2f2f2'", v-b-tooltip.hover, title="Cambiar color", rounded, id="dashboard_color_picker", style="border:1px dashed #ddd;")
            .mt-3
              p.text-secondary {{ dashboardColor || '#f2f2f2' }}
              b-button(variant="primary", size="sm", @click="updateAccount('shop')", :disabled="loading") Guardar color
          b-col.d-none.d-md-block(cols="auto", order="1")
            b-card.product-card.mb-1(no-body, style="width:200px;")
              .card-cover.bg-light
                b-img.empty-image(src="@/assets/icons/empty.png")
              .p-3
                p.title.mb-2(style="font-weight:600;cursor:pointer;") Producto increíble
                h5.mb-3 $150.00
                b-button(block, :style="{color: BWTextColor(dashboardColor), 'background-color': dashboardColor, 'border-color': dashboardColor}")
                  shopping-cart-icon.mr-2.button-icon(style="width:13px;height:13px;")
                  span.button-text(style="font-size:13px;") Agregar al carrito
            
            p.text-secondary.text-sm Vista previa de color

    h5.mb-3 Personaliza el Chat de tu tienda en línea
    widget-config(v-if="chatbot", :chatbot="chatbot", @update="getBmessanging()")
    
    b-popover(target="dashboard_color_picker", triggers="click blur", placement="top", custom-class="color-picker-popover")
      color-picker(:value="dashboardColor", @input="dashboardColor = $event.hex", key="dash-color")
</template>

<script>
import WidgetConfig from "../../components/WidgetConfig";
import { createNamespacedHelpers, mapActions } from 'vuex'
 import { Sketch } from 'vue-color'
import treeselectOptions from '@/data/treeselect-options'
import UserVariablesListVue from '../../components/UserVariablesList.vue';

import { UploadFile } from '@/helpers/upload-file'
import { toBase64 } from '@/helpers/file-converter'

import { BWTextColor } from '@/helpers/contrast-color-generator'

const accountController = createNamespacedHelpers('account')


export default {
  data () {
    return {
      username: '',
      isUsernameAvailable: true,
      validating: false,
      treeselect_options: treeselectOptions,
      bmid: null,
      chatbot: null,
      suggestion: '',
      businessManagerLink: '',
      validationFileCreated: false,
      creatingFile: false,
      coverPhoto: '',
      dashboardColor: '',
      image: '',
      loading: false
    }
  },
  computed: {
    ...accountController.mapState({
      account: state => state.account,
      bmessaging: state => state.bmessaging,
    }),
    usernameState () {
      if (this.username == this.account.username) return null
      if (this.username.length == 0) return false
      return (new RegExp("^[A-Za-z0-9](?:[A-Za-z0-9\-]{0,61}[A-Za-z0-9])?$")).test(this.username) && this.isUsernameAvailable
    },
    parsedBMs () {
      return this.bmessaging.map(a => {
        return {
          id: a.bmid,
          label: a.name
        }
      })
    },
    isValidBusinessManagerLink () {
      let regex = RegExp(`https?:\/\/${this.account.username}\.konverza\.me\/[a-z0-9]+\.html`)
      return regex.test(this.businessManagerLink)
    }
  },
  methods: {
    BWTextColor: BWTextColor,
    ...mapActions(['account/validateUsername', 'account/get', 'account/update', 'account/bmessaging', 'helpers/upload_file']),
    validateUsername () {
      this.suggestion = ''
      this.validating = true
      this['account/validateUsername']({
        username: this.username,
        callback: res => {
          this.isUsernameAvailable = Boolean(res.available)
          this.validating = false
          this.suggestion = res.suggestion
        }
      })
    },
    async updateAccount (service) {
      this.validating = true
      let updateData = {};

      switch (service) {
        case 'ig':
          this.creatingFile = true;
          updateData.business_manager_instagram_link = this.businessManagerLink;
          break;
        case 'username':
          updateData.username = this.username;
          break;
        case 'shop':
          updateData.cover_photo = this.coverPhoto;
          updateData.image = this.image;
          updateData.main_color_dashboard = this.dashboardColor;
          break;
        default:
          return;
      }

      if (service == 'shop') {
        if (this.file_image) {
          try {
            updateData.image = await UploadFile.call(this, this.file_image)
          } catch (e) {
            console.log(e)
            this.image = ''
            updateData.image = ''
            this.loading = false
            this.$message.error('Error subiendo imagen')
            return
          }
        }

        if (this.file_coverPhoto) {
          try {
            updateData.cover_photo = await UploadFile.call(this, this.file_coverPhoto)
          } catch (e) {
            console.log(e);
            this.coverPhoto = ''
            updateData.cover_photo = ''
            this.loading = false
            this.$message.error('Error subiendo portada')
            return
          }
        }
      }

      this['account/update']({
        account_id: this.$route.params.account_id,
        ...updateData,
        callback: res => {
          this.validating = false
          if (res.error) {
            this.$message.error(res.error)
            if (service == 'ig') this.creatingFile = false;
          } else {
            this.$message.success('Cuenta actualizada.')
            this['account/get']({
              account_id: this.$route.params.account_id
            })

            if (service == 'ig') {
              this.creatingFile = false;
              this.validationFileCreated = true;
            }
          }
        }
      })
    },
    selectChat () {
      this.chatbot = null
      let self = this
      this.$nextTick(() => {
        self.chatbot = this.bmessaging.find(b => b.bmid == self.bmid)
        if(self.chatbot) {
          let element = document.getElementById("botConfig");
          element.scrollIntoView({block: "end", behavior: "smooth"});
        }
      })
    },
    getBmessanging() {
      let self = this
      this['account/bmessaging']({
        account_id: self.$route.params.account_id,
        callback: res => {
          if (res.error) {
            self.$message.error(res.error)
          }
        }
      })
    },
    imagePicked (event, key) {
      let file = event.target.files[0]
      this['file_' + key] = file
      this[key] = URL.createObjectURL(file)
      this.$refs.input_image.value = ''
      this.$refs.input_coverPhoto.value = ''
    },
  },
  mounted () {
    this.username = this.account.username
    this.chatbot = this.bmessaging[0]
    this.businessManagerLink = this.account.business_manager_instagram_link || ''

    this.dashboardColor = this.account.main_color_dashboard || '#f2f2f2';
    this.coverPhoto = this.account.cover_photo;
    this.image = this.account.image;

    console.log(this.account);
  },
  components: {WidgetConfig, 'color-picker': Sketch},
  watch: {
    username (value) {
      if (value == this.account.username || !this.usernameState) return
      this.$nextTick(() => {
        this.validateUsername()
      })
    },
    account (value) {
      this.username = value.username
      this.businessManagerLink = value.business_manager_instagram_link || ''

      this.dashboardColor = this.account.main_color_dashboard || '#f2f2f2';
      this.coverPhoto = this.account.cover_photo;
      this.image = this.account.image;

      console.log(value);
    },
    bmessaging (value) {
      if (!this.chatbot && value.length) {
        this.chatbot = value[0]
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .cover-container {
    width: 100%;
    padding-top: 42.85%;
    position:relative;

    img {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      width: 100%;
      height: 100%;
    }
  }

  .color-picker-popover {
    min-width: 244px !important;
    max-width: 244px !important;
  }

  .card-cover {
    width: 100%;
    height: auto;
    padding-top: 100%;
    position: relative;

    .image-cover {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      object-fit: cover;
    }

    .empty-image {
      width: 30%;
      height: 30%;
      position: absolute;
      top: calc(33.33%);
      left: calc(33.33%);
      z-index: 1;
    }
  }

  span.title:hover {
    text-decoration: underline;
  }

  .browser-container {
    border-top: 1px solid black;
    border-right: 1px solid black;
    border-left: 1px solid black;
    border-top-right-radius: 5px;
    border-top-left-radius: 5px;

    .status-bar {
      background:#fafafa;
      padding: 10px 15px;
      border-top-right-radius: 5px;
      border-top-left-radius: 5px;

      .buttons {
        width: 10px;
        height: 10px;
        border-radius: 50%;
        background: white;

        &.green {
          background: green;
        }

        &.yellow {
          background: rgb(228, 231, 14);
        }

        &.red {
          background: red;
        }
      }
    }

    .search-bar {
      background-color: #fafafa;
      padding: 10px 15px;

      .bar {
        border: 1px solid #ddd;
        border-radius: 5px;
        padding: 5px;
      }
    }
  }
</style>
